var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifyBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6668_1492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.674 26C12.4851 26 14.0001 24.6013 14.348 22.75H7C7.34808 24.6013 8.8631 26 10.674 26Z",
    fill: "#FF3C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5759 15.5372C18.5499 15.5372 18.5259 15.5415 18.4999 15.5415C16.8887 11.8333 19.2499 6.83327 15.3887 3.83327C13.8373 2.62797 13 2.5 12.0001 1.84171V0.916534C12.0001 0.317474 11.552 -0.166733 10.9999 -0.166733C10.4481 -0.166733 10 0.317474 10 0.916534V2.08669C6.61292 2.61533 4 5.7711 4 9.58327V12.6036C4 14.7475 3.133 16.7712 1.61194 18.1643C1.22302 18.5251 1 19.0494 1 19.604C1 20.6496 1.78497 21.5 2.74994 21.5H19.2499C20.2151 21.5 21.0001 20.6496 21.0001 19.604C21.0001 19.0494 20.777 18.5251 20.3781 18.1558C19.59 17.4331 18.9821 16.534 18.5759 15.5372Z",
    fill: "#FF7705",
    fillOpacity: 0.88
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6668_1492"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyBell);
export default __webpack_public_path__ + "static/media/notify-bell.6b4b9ee2a20260fdcf46b6bb9f799112.svg";
export { ForwardRef as ReactComponent };